
export default {
  pathObj:[
    {//H5子活动
      "path": "/pages/yWebView/index",
      "name": "yWebView"
    },
    {
      "path": "/pages/goods/index",
      "name": "goods"
    },
    {//商品列表
      "path": "/module/other/pages/goodsList/index",
      "name": "goodsList",
    },
    {//新人专区
      "path": "/module/other/pages/newbies/index",
      "name": "newbies",
    },
    {//限时抢购
      "path": "/module/other/pages/flashSale/index",
      "name": "flashSale",
    },
    {//拼团专区
      "path": '/module/activity/pages/groupBuy/index',
      "name":"groupBuy",
    },
    {//预售卡专区
      "path": '/module/activity/pages/preSaleZone/index',
      "name": "preSaleZone",
    },
    {//预售卡礼包详情
      "path": '/module/activity/pages/preSale/index',
      "name": "preSaleDetail",
    },
    {//分享有礼
      "path": '/module/activity/pages/fissionShare/index',
      "name": "fissionShare",
    },
    {//优惠券
      "path": "/module/activity/pages/couponDetails/index",
      "name": "couponDetails",
    },
    {//群接龙
      "path": '/module/activity/pages/groupRelay/index',
      "name":"groupRelay",
    },
    {//任选活动
      "path": '/module/activity/pages/optional/index',
      "name": "optional",
    },
    {//领券中心
      "path": "/module/other/pages/couponCenter/index",
      "name": "couponCenter",
    },
    {//邀请好友
      "path": "/module/other/pages/toInvitation/index",
      "name": "toInvitation",
    },
    {//会员权益
      "path": "/module/other/pages/openMember/index",
      "name": "openMember",
    },
    {//组合礼包
      "path": "/module/other/pages/giftPacksList/index",
      "name": "giftPacksList",
    },
    {//视频素材列表
      "path": '/module/material/pages/videoList/index',
      "name": 'videoList',
    },
    {//图文素材列表
      "path": '/module/material/pages/articleList/index',
      "name": 'articleList',
    },
    {//视频素材详情
      "path": '/module/material/pages/video/index',
      "name": "video",
    },
    {//图文素材详情
      "path": '/module/material/pages/article/index',
      "name": "article",
    },
  ]
}



// WEBPACK FOOTER //
// ./src/module/app/activityPage/path.js